"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LossReason = void 0;
var LossReason;
(function (LossReason) {
    LossReason["Price"] = "Price";
    LossReason["NotAvailable"] = "Not Available";
    LossReason["Other"] = "Other";
    LossReason["DeliveryTime"] = "Delivery Time";
    LossReason["ScopeMismatch"] = "Scope Mismatch";
    LossReason["RegionalNonAvailability"] = "Regional Non Availability";
    LossReason["ClientCancellation"] = "Client Cancellation";
    LossReason["OperatorUnavailability"] = "Operator Unavailability";
    LossReason["ClientOnCreditWorthiness"] = "Client On Credit Worthiness";
})(LossReason = exports.LossReason || (exports.LossReason = {}));
//# sourceMappingURL=procurement.js.map